<template>
  <div class="home">
    <video
      style="
        position: absolute;
        top: -56px;
        width: 100%;
        height: 100vh;
        object-fit: cover;
        z-index: 0;
      "
      :src="
        'https://nncms.actstudio.xyz/storage/uploads/' + home.videoFondo.path
      "
      autoplay
      loop
      muted
    ></video>

    <!-- Bloque presentacion -->
    <div style="z-index: 1; position: relative; background-color: #5c27b2a6;">
      <v-container class="">
        <v-row align="center" class="logo-space">
          <v-col>
            <v-img
              src="../assets/img/neutralnetworks_blanco.svg"
              width="300"
            ></v-img>
          </v-col>
        </v-row>

        <v-row style="height: calc(100vh - 56px - 400px)" align="center">
          <v-col cols="12">
            <v-carousel
              :hide-delimiters="true"
              :show-arrows="false"
              cycle
              height="250"
              class="d-none d-md-block"
            >
              <v-carousel-item
                v-for="(texto, textoID) in home.textosIniciales"
                :key="'id' + textoID"
                transition="fade-transition"
                reverse-transition="fade-transition"
              >
                <span
                  class="montserrat bold enfasis-size d-none d-sm-block white--text"
                  style="white-space: pre"
                  >{{ texto.value }}</span
                >
                <span class="montserrat bold enfasis-size d-sm-none white--text">{{
                  texto.value
                }}</span>
              </v-carousel-item>
            </v-carousel>

            <v-carousel
              :hide-delimiters="true"
              :show-arrows="false"
              cycle
              height="120px"
              class="d-md-none"
            >
              <v-carousel-item
                v-for="(texto, textoID) in home.textosIniciales"
                :key="'id' + textoID"
                transition="fade-transition"
                reverse-transition="fade-transition"
              >
                <span
                  class="montserrat bold enfasis-size d-none d-sm-block white--text"
                  style="white-space: pre"
                  >{{ texto.value }}</span
                >
                <span class="montserrat bold enfasis-size d-sm-none white--text">{{
                  texto.value
                }}</span>
              </v-carousel-item>
            </v-carousel>
            <div class="home-intro-descipcion">
              <hr class="mb-3 mb-sm-6 color-blanco home-intro-descipcion-line" />
              <!-- <span
                class="montserrat single-item-size line-height-1 d-none d-sm-block" style="white-space: break-spaces;"
              >{{home.textoSecundario}}</span> -->
              <v-img
                src="../assets/img/an-evengroup-company_logo-blanco.svg"
                width="255"
                :contain="true"
              ></v-img>
            </div>
          </v-col>
        </v-row>
        <!-- <v-row style="height: 100px" class="my-0">
          <v-col>
            <v-img
              src="../assets/img/an-evengroup-company_logo-blanco.svg"
              width="255"
              :contain="true"
            ></v-img>
          </v-col>
        </v-row> -->
      </v-container>
    </div>
    <!-- Termina bloque presentacion -->


    <!-- Inicia Productos -->
    <v-container fluid class="mt-0">
      <v-row>
        <v-col cols="12" md="4" class="text-center metro-background">
          <div class="pa-12">
            <v-img src="../assets/img/logo-metro-blanco.png" max-width="300px" height="75px" contain class="mx-auto" style="position: relative; z-index: 100"></v-img>
            <div class="home-product-text">
              <p class="white--text my-12 d-block">{{home.descripcionMetro}}</p>
            </div>

            <div class="mb-6">
              <v-carousel height="150px" :hide-delimiters="true" :show-arrows="false" cycle continuous>
                <v-carousel-item class="white--text">
                  <v-img src="../assets/img/fibra-icon.png" width="70px" class="d-block mx-auto"></v-img>
                  <span class="white--text mt-6 d-block">
                    <template v-if="lang == 'en'">
                      Dark Fiber
                    </template>
                    <template v-else>
                      Fibra Oscura
                    </template>
                  </span>
                </v-carousel-item>

                <v-carousel-item class="white--text">
                  <v-img src="../assets/img/Internet.png" width="70px" class="d-block mx-auto"></v-img>
                  <span class="white--text mt-6 d-block">Internet</span>
                </v-carousel-item>

                <v-carousel-item class="white--text">
                  <v-img src="../assets/img/Ethernet.png" width="70px" class="d-block mx-auto"></v-img>
                  <span class="white--text mt-6 d-block">Ethernet</span>
                </v-carousel-item>
              </v-carousel>
            </div>

            <v-btn color="white my-12" outlined block tile to="/productos/metro">
              <template v-if="lang == 'en'">
                Read more
              </template>
              <template v-else>
                Ver más
              </template>
            </v-btn>
          </div>
        </v-col>
        
        <v-col cols="12" md="4" class="text-center link-background">
          <div class="pa-12">
            <v-img src="../assets/img/logo-link-blanco.png" max-width="300px" height="75px" contain class="mx-auto" style="position: relative; z-index: 100"></v-img>
            <div class="home-product-text">
              <p class="white--text my-12 d-block">{{home.descripcionLink}}</p>
            </div>

            <div class="mb-6">
              <v-carousel height="150px" :hide-delimiters="true" :show-arrows="false" cycle continuous>
                <v-carousel-item class="white--text">
                  <v-img src="../assets/img/fibra-icon.png" width="70px" class="d-block mx-auto"></v-img>
                  <span class="white--text mt-6 d-block">
                    <template v-if="lang == 'en'">
                      Dark Fiber
                    </template>
                    <template v-else>
                      Fibra Oscura
                    </template>
                  </span>
                </v-carousel-item>

                <v-carousel-item class="white--text">
                  <v-img src="../assets/img/Ethernet.png" width="70px" class="d-block mx-auto"></v-img>
                  <span class="white--text mt-6 d-block">Ethernet</span>
                </v-carousel-item>
              </v-carousel>
            </div>

            <v-btn color="white my-12" outlined block tile to="/productos/link">
              <template v-if="lang == 'en'">
                Read more
              </template>
              <template v-else>
                Ver más
              </template>
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12" md="4" class="text-center next-background">
          <div class="pa-12">
            <v-img src="../assets/img/logo-next-blanco.png" max-width="300px" height="75px" contain class="mx-auto" style="position: relative; z-index: 100"></v-img>
            <div class="home-product-text">
              <p class="white--text my-12 d-block">{{home.descripcionNext}}</p>
            </div>

            <div class="mb-6">
              <v-carousel height="150px" :hide-delimiters="true" :show-arrows="false" cycle continuous>
                <v-carousel-item class="white--text">
                  <v-img src="../assets/img/fibra-icon.png" width="70px" class="d-block mx-auto"></v-img>
                  <span class="white--text mt-6 d-block">
                    <template v-if="lang == 'en'">
                      Dark Fiber
                    </template>
                    <template v-else>
                      Fibra Oscura
                    </template>
                  </span>
                </v-carousel-item>

                <v-carousel-item class="white--text">
                  <v-img src="../assets/img/Internet.png" width="70px" class="d-block mx-auto"></v-img>
                  <span class="white--text mt-6 d-block">Internet</span>
                </v-carousel-item>

                <v-carousel-item class="white--text">
                  <v-img src="../assets/img/Ethernet.png" width="70px" class="d-block mx-auto"></v-img>
                  <span class="white--text mt-6 d-block">Ethernet</span>
                </v-carousel-item>
              </v-carousel>
            </div>

            <v-btn color="white my-12" outlined block tile to="/productos/next">
              <template v-if="lang == 'en'">
                Read more
              </template>
              <template v-else>
                Ver más
              </template>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!-- Termina productos -->

    <!-- Neutral Networks en números -->
    <!-- <v-container class="py-12">
      <v-row>
        <v-col class="text-center">
          <template v-if="lang == 'es'">
            <span class="montserrat bold titulos-size color-morado"
              >Neutral Networks en Números</span
            >
          </template>
          <template v-else>
            <span class="montserrat bold titulos-size color-morado"
              >Neutral Network's Numbers</span
            >
          </template>
        </v-col>
      </v-row>

      <v-row align-md="center">
        <v-col
          v-for="(item, enNumerosID) in home.enNumeros"
          cols="6"
          md="4"
          :key="'enNumeros' + enNumerosID"
          class="text-center my-7"
        >
          <v-img
            :src="'https://nncms.actstudio.xyz' + item.value.icono.path"
            width="90"
            class="mx-auto mb-4"
          >
          </v-img>
          <span class="d-inline-block color-morado" style="font-size: 18px">{{
            item.value.primerTextoRegular
          }}</span>
          <span class="d-inline-block color-morado" style="font-size: 28px">{{
            item.value.primerTextoBold
          }}</span>
          <span class="d-block color-morado" style="font-size: 18px">
            {{ item.value.segundoTexto }}
          </span>
        </v-col>
      </v-row>
    </v-container> -->
    <!-- Termina Neutral Networks en números -->

    <!-- Inicia mapa -->
    <!-- <div class="d-none d-md-block"> -->
    <div>
      <MapaHome></MapaHome>
    </div>
    <div class="d-none">
      <MapaHomeMovil></MapaHomeMovil>
    </div>
    <!-- <div class="py-6" style="background: rgb(72, 48, 110);">
      <v-container class="py-0">
        <v-row>
          <v-col class="text-center">
            <span class="bold white--text">KMZ</span>
          </v-col>
        </v-row>
        <div class="mx-auto" style="max-width: 800px">
          <v-row class="mt-0">
            <v-col cols="6" sm="3" v-for="(item,kmzn) in kmz" :key="'KMZs-'+kmzn">
              <v-btn :href="'https://nncms.actstudio.xyz/storage/uploads/'+item.file.path" text dark target="_blank"> <v-icon>mdi-download</v-icon> <span style="text-transform: none"> {{item.name}} </span></v-btn>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </div> -->
    <!-- Termina mapa -->

    <!-- Inicia Productos -->
    
    <v-container class="my-12" v-if="false">
      <v-row>
        <v-col class="text-center">
          <template v-if="lang == 'es'">
            <span class="montserrat bold titulos-size color-morado"
              >Productos</span
            >
          </template>
          <template v-else>
            <span class="montserrat bold titulos-size color-morado"
              >Products</span
            >
          </template>
        </v-col>
      </v-row>

      <template v-if="destacados.length > 0">
        <div style="position: relative;">
          <v-row class="pa-0">
            <v-col class="pa-0 px-3 px-sm-12">
              <carousel :nav="false" :loop="true" :dots="false" :items="4" :margin="30" :responsive="{0:{items:1},768:{items:2},960:{items: 3}, 1264:{items: 4}}" class="owl-car">

                <div v-for="(destacado, d) in destacados" :key="'destacado-' + d">
                  <v-container class="px-sm-0">
                    <v-row>
                      <v-col class="px-0">
                        <v-card color="#5C27B2" dark :height="cardHeight" class="mx-2">
                          <img
                            class="white--text align-end"
                            width="100%"
                            :src="
                              'https://nncms.actstudio.xyz' +
                              destacado.imagenCover.path
                            "
                            eager
                            style="height: 120px; width: 100%; object-fit: cover;"
                          >

                          <v-card-text class="text-center px-md-5">
                            <div class="home-card-content">
                              <span
                                class="d-block bold titulos-size uppercase my-3 color-blanco"
                                >{{ destacado.name }}</span
                              >
                              <p
                                class="texto-corrido-size my-6 color-blanco home-card-descripcionCorta"
                              >
                                {{ destacado.descripcionCorta }}
                              </p>
                            </div>
                            <template v-if="lang == 'en'">
                              <v-btn
                                :to="'/servicios/' + destacado.url"
                                class="my-6"
                                outlined
                                width="210"
                                height="35"
                              >
                                See more
                              </v-btn>
                            </template>
                            <template v-else>
                              <v-btn
                                :to="'/servicios/' + destacado.url"
                                class="my-6"
                                outlined
                                width="210"
                                height="35"
                              >
                                Ver más
                              </v-btn>
                            </template>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </div>
                <template slot="next"><v-icon class="pointer">mdi-chevron-right</v-icon></template>
                <template slot="prev"><v-icon class="pointer">mdi-chevron-left</v-icon></template>
              </carousel>
            </v-col>
          </v-row>

        </div>
      </template>
    </v-container>

    <div style="background-size: cover; position: relative">
      <div style="position: absolute; width: 100%; height: 100%; z-index: 0">
        <video
          style="
            position: absolute;
            width: 100%;
            height: 100%;
            object-fit: cover;
            z-index: 0; 
          "
          :src="
            'https://nncms.actstudio.xyz/storage/uploads/' +
            home.videoFondo.path
          "
          autoplay
          loop
          muted
        ></video>
      </div>
      <div style="background: #5c27b2a6; position: relative">
        <v-container>
          <v-row class="py-10">
            <v-col class="text-center">
              <template v-if="lang == 'en'">
                <router-link to="/NuestraDiferencia" style="text-decoration: none;">
                  <span class="montserrat bold enfasis-size color-blanco"
                    >Our value proposition</span
                  >
                </router-link>
              </template>
              <template v-else>
                <router-link to="/NuestraDiferencia" style="text-decoration: none;">
                  <span class="montserrat bold enfasis-size color-blanco"
                    >Nuestra Oferta de Valor</span
                  >
                </router-link>
              </template>
            </v-col>
          </v-row>
          <v-row align="center" style="height: 330px">
            <v-col cols="12">
              <v-carousel height="100px" hide-delimiter-background hide-delimiters :show-arrows="false" cycle interval="3000" continuous>
                <v-carousel-item v-for="(oferta, ofertaID) in home.ofertasDeValor" :key="'ofertaValor-' + ofertaID" class="text-center" transition="fade-transition" reverse-transition="fade-transition">
                  <router-link to="/NuestraDiferencia" style="text-decoration: none;">
                    <v-icon color="white">mdi-plus</v-icon> <span class="montserrat bold color-blanco enfasis-size valign-middle">{{oferta.value}}</span>
                  </router-link>
                </v-carousel-item>
              </v-carousel>
            </v-col>
            <!-- <v-col
              cols="12"
              md="4"
              class="text-center"
              v-for="(oferta, ofertaID) in home.ofertasDeValor"
              :key="'ofertaValor' + ofertaID"
            >
              <v-icon color="white">mdi-plus</v-icon>
              <span
                class="montserrat bold color-blanco enfasis-size valign-middle"
                >{{ oferta.value }}</span
              >
            </v-col> -->
          </v-row>
        </v-container>
      </div>
    </div>
    <!-- Termina nuestra oferta de valor -->
  </div>
</template>


<script>
// import { Splide, SplideSlide } from "@splidejs/vue-splide";
// import "@splidejs/splide/dist/css/themes/splide-default.min.css";
import carousel from 'vue-owl-carousel'

export default {
  name: "Home",
  data() {
    return {
      kmz: [],
      home: {
        imagenOfertaValor: {
          path: "",
        },
        videoFondo: {
          path: "",
        },
      },
      destacados: [],
      options: {
        width: "100%",
        rewind: true,
        type: "loop",
        pagination: false,
        // arrowPath:'../assets/img/left_slide.svg',
        perPage: 4,
        perMove: 1,
        gap: 30,
        trimSpace: true,
        breakpoints: {
          600: {
            perPage: 1,
          },
          960: {
            perPage: 2,
          },
          1264: {
            perPage: 3,
          },
          1904: {
            perPage: 4,
          },
        },
      },
    };
  },
  components: {
    MapaHome: () => import("../components/MapaHome.vue"),
    MapaHomeMovil: () => import("../components/MapaHomeMovil.vue"),
    // Splide,
    // SplideSlide,
    carousel
  },
  
  mounted: function () {
    if (this.lang == "en") {
      fetch(
        "https://nncms.actstudio.xyz/api/singletons/get/Home?token=8cf7ca41761951fdde0c1e2cfda401",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            populate: 1, // resolve linked collection items
            lang: "en", // return normalized language fields (fieldA_de => fieldA)
          }),
        }
      )
        .then((data) => data.json())
        .then((data) => (this.home = data));

      fetch(
        "https://nncms.actstudio.xyz/api/collections/get/Servicios?token=8cf7ca41761951fdde0c1e2cfda401",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            filter: {
              destacado: true,
              activo: true,
            },
            sort: { _o: 1 },
            populate: 1, // resolve linked collection items
            lang: "en", // return normalized language fields (fieldA_de => fieldA)
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => (this.destacados = res.entries));

      fetch(
        "https://nncms.actstudio.xyz/api/collections/get/KMZ?token=8cf7ca41761951fdde0c1e2cfda401",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            lang: "en", // return normalized language fields (fieldA_de => fieldA)
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => (this.kmz = res.entries));
    } else {
      fetch(
        "https://nncms.actstudio.xyz/api/singletons/get/Home?token=8cf7ca41761951fdde0c1e2cfda401",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            populate: 1, // resolve linked collection items
            lang: "de", // return normalized language fields (fieldA_de => fieldA)
          }),
        }
      )
        .then((data) => data.json())
        .then((data) => (this.home = data));

      fetch(
        "https://nncms.actstudio.xyz/api/collections/get/Servicios?token=8cf7ca41761951fdde0c1e2cfda401",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            filter: {
              destacado: true,
              activo: true,
            },
            sort: { _o: 1 },
            populate: 1, // resolve linked collection items
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => (this.destacados = res.entries));

      fetch(
        "https://nncms.actstudio.xyz/api/collections/get/KMZ?token=8cf7ca41761951fdde0c1e2cfda401",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({}),
        }
      )
        .then((res) => res.json())
        .then((res) => (this.kmz = res.entries));
    }

    this.$gtag.pageview({ page_path: '/', page_title: 'Home' })
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    cardHeight: function () {

      if(this.$vuetify.breakpoint.width < 1800){
        return 450;
      }

      return 430;
    }
  },
  watch: {
    lang() {
      if (this.$i18n.locale == "en") {
        //obtener un proyecto del parametro de projecto
        fetch(
          "https://nncms.actstudio.xyz/api/singletons/get/Home?token=8cf7ca41761951fdde0c1e2cfda401",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              lang: "en",
            }),
          }
        )
          .then((data) => data.json())
          .then((data) => (this.home = data));

        fetch(
          "https://nncms.actstudio.xyz/api/collections/get/Servicios?token=8cf7ca41761951fdde0c1e2cfda401",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              filter: {
                destacado: true,
                activo: true,
              },
              sort: { _o: 1 },
              populate: 1, // resolve linked collection items
              lang: "en",
            }),
          }
        )
          .then((res) => res.json())
          .then((res) => (this.destacados = res.entries));

        fetch(
          "https://nncms.actstudio.xyz/api/collections/get/KMZ?token=8cf7ca41761951fdde0c1e2cfda401",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              lang: "en", // return normalized language fields (fieldA_de => fieldA)
            }),
          }
        )
          .then((res) => res.json())
          .then((res) => (this.kmz = res.entries));
      } else if (this.$i18n.locale == "es") {
        //obtener un proyecto del parametro de projecto
        fetch(
          "https://nncms.actstudio.xyz/api/singletons/get/Home?token=8cf7ca41761951fdde0c1e2cfda401"
        )
          .then((data) => data.json())
          .then((data) => (this.home = data));
        fetch(
          "https://nncms.actstudio.xyz/api/collections/get/Servicios?token=8cf7ca41761951fdde0c1e2cfda401",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              filter: {
                destacado: true,
                activo: true,
              },
              sort: { _o: 1 },
              populate: 1, // resolve linked collection items
            }),
          }
        )
          .then((res) => res.json())
          .then((res) => (this.destacados = res.entries));

        fetch(
          "https://nncms.actstudio.xyz/api/collections/get/KMZ?token=8cf7ca41761951fdde0c1e2cfda401",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({}),
          }
        )
          .then((res) => res.json())
          .then((res) => (this.kmz = res.entries));
      }
    },
  },
};
</script>
